import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import {
  WarrantOrganizationCreationPayload,
  WarrantOrganizationCreationResponseData,
} from './warrants-create-organization-types';

// createSilobagService
export async function warrantOrganizationCreationService({ body }: WarrantOrganizationCreationPayload) {
  const { response, data } = await BACKEND.post<WarrantOrganizationCreationResponseData>(
    ENDPOINT.WARRANT_COMPANY,
    { body }
  );

  return {
    response,
    summary: data,
  };
}
